import { render, staticRenderFns } from "./djs.vue?vue&type=template&id=4ba8fd1a&"
import script from "./djs.vue?vue&type=script&lang=js&"
export * from "./djs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports